import { useState, type ReactNode } from 'react';
import { AppShell } from '@mantine/core';
import { TopBar } from './TopBar';
import { SideNav } from './SideNav';

export function Shell({ children }: { children: ReactNode }) {
  const [navOpened, setNavOpened] = useState(false);

  return (
    <AppShell
      header={{ height: 56 }}
      navbar={{
        width: 240,
        breakpoint: 'sm',
        collapsed: { mobile: !navOpened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <TopBar navOpened={navOpened} onToggleNav={() => setNavOpened((v) => !v)} />
      </AppShell.Header>

      <AppShell.Navbar>
        <SideNav />
      </AppShell.Navbar>

      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  );
}
